export function getScoreLabel(score) {
  if (score >= 80) return 'Distinction';
  if (score >= 50) return 'Pass';
  return 'Poor';
}

export function getScoreColor(label) {
  switch (label) {
    case 'Distinction': return 'text-emerald-600';
    case 'Pass': return 'text-amber-600';
    case 'Poor': return 'text-rose-500';
  }
}

export function getScoreBg(label) {
  switch (label) {
    case 'Distinction': return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    case 'Pass': return 'bg-amber-50 text-amber-700 border-amber-200';
    case 'Poor': return 'bg-rose-50 text-rose-700 border-rose-200';
  }
}
